<template>
  <v-card
    class="pa-1 ma-0 d-flex flex-wrap justify-center align-stretch transparent"
    elevation="0"
  >
    <v-card
      v-for="(item, id) in items"
      :key="id"
      class="ma-1 py-1 d-flex justify-center"
      elevation="8"
      :width="$vuetify.breakpoint.xs ? 320 : 320"
    >
      <v-card
        class="pa-3"
        :width="$vuetify.breakpoint.xs ? 320 : 320"
        elevation="0"
      >
        <v-container class="d-flex flex-space-between pa-0">
          <v-container class="font-weight-bold text-body-2 pa-0"
            >Order Detail</v-container
          >
          <v-container class="font-weight-bold text-body-2 text-center pa-0">{{
            item.tableName
          }}</v-container>
          <v-container class="font-weight-bold text-body-2 text-right pa-0">{{
            item.customer.name
          }}</v-container>
        </v-container>

        <v-divider class="mt-4"></v-divider>

        <div v-for="detail in item.checkout_details" :key="detail.id">
          <div class="mt-2 pa-0">
            <v-card
              class="d-flex mt-2 pa-4"
              elevation="0"
              :width="$vuetify.breakpoint.xs ? 320 : 320"
            >
              <div class="pa-0 mr-3">
                <v-avatar :size="$vuetify.breakpoint.xs ? 20 : 45" tile>
                  <v-img :src="detail.image"></v-img>
                </v-avatar>
              </div>
              <v-container
                class="pa-0 mt-n1 d-flex flex-column justify-space-between"
              >
                <div>
                  <h4>{{ detail.menu }}</h4>
                  <p class="ma-0 font-weight-medium">
                    QTY: {{ detail.quantity }}
                  </p>
                  <h6 class="ma-0 font-weight-light text-justify">
                    {{ detail.note }}
                  </h6>
                </div>
                <v-container
                  class="d-flex justify-space-between pa-0 ma-0"
                  width="200"
                  elevation="3"
                >
                  <div></div>
                  <v-container
                    v-if="detail.status == 'accept'"
                    class="pa-0 mt-2"
                  >
                    <v-btn
                      class="ma-0 pa-0"
                      elevation="1"
                      height="23"
                      block
                      color="myOrange white--text font-weight-black"
                      @click="changeStatus([item.id, detail.id])"
                      >{{ detail.status }}</v-btn
                    >
                  </v-container>
                  <v-container
                    v-else-if="detail.status == 'on going'"
                    class="pa-0 mt-2"
                  >
                    <v-btn
                      class="ma-0 pa-0"
                      elevation="1"
                      height="23"
                      block
                      color="myYellow white--text font-weight-black"
                      @click="changeStatus([item.id, detail.id])"
                      >{{ detail.status }}</v-btn
                    >
                  </v-container>
                  <v-container v-else class="pa-0 mt-2">
                    <v-btn
                      class="ma-0 pa-0"
                      elevation="1"
                      height="23"
                      block
                      color="myGreen white--text font-weight-black"
                      @click="changeStatus([item.id, detail.id])"
                      >{{ detail.status }}</v-btn
                    >
                  </v-container>
                  <!-- <v-card class="d-flex" elevation="0">
                                        <v-btn x-small block color="myGreen white--text">DONE</v-btn>
                                    </v-card> -->
                </v-container>
              </v-container>
            </v-card>
            <v-divider></v-divider>
          </div>
        </div>
        <v-container>
          <v-btn
            @click="changeStatusParent(item.id)"
            block
            color="myBlue white--text"
            :disabled="onBtnStatus(item.id)"
            >All Done</v-btn
          >
        </v-container>
      </v-card>
    </v-card>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      cart: [
        {
          id: 1,
          src: "http://lorempixel.com/400/200/food/",
          title: "Japanese (Ice)",
          quantity: 1,
          table_name: "A1",
          customer: "Yoga",
          note:
            "Sambelnya banyakin pedes g apedes tapi bohong hahahaha budi nya anjing, anjingnya budi kek kontol",
        },
        {
          id: 2,
          src:
            "https://image.freepik.com/free-photo/black-coffee-white-cup-surrounded-by-citrus-dried-fruits_158518-2442.jpg",
          title: "Black Party (Ice)",
          quantity: 2,
          table_name: "A3",
          customer: "Dzaki",
          note: "Gulanya dikit",
        },
      ],
      status: "confirm",
    };
  },
  computed: {
    ...mapGetters(["items"]),
  },
  methods: {
    ...mapActions(["getItems", "changeStatus", "changeStatusParent"]),
    onBtnStatus(id) {
      const myFunction = this.items
        .find((item) => item.id == id)
        .checkout_details.map((detail) => detail.status)
        .every((status) => status == "done");

      if (myFunction) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>
